import type { FinanceInfo } from '~/contracts';
import FinanceInfoFromApi from '~/services/contracts/FinanceInfo';

export default function formatFinanceInfo(
  financeInfo: FinanceInfoFromApi
): FinanceInfo {
  return {
    ...financeInfo,
    baseMinDownPayment: financeInfo.baseMinDownPayment ?? undefined
  };
}
